import React, { useState } from "react";
import { TextField, Grid, Slide } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";
import { TransitionProps } from "@mui/material/transitions";
import { Select, MenuItem, FormControl, Typography } from "@mui/material";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide
      direction="left"
      timeout={{ enter: 2000, exit: 400 }}
      ref={ref}
      {...props}
    />
  );
});
export default function ReferralsPopup(props: any) {
  const [formData, setFormData] = useState({
    patientName: "",
    recallDate: "",
    recallReason: "",
    referringDoctor: "",
    referredDoctor: "",
    referralReason: "",
    rxStartingDate: "",
    rxProviderName: "",
    rxQuantity: "",
    rxMedicineUnits: "",
    rxMedicineUnitsType: "",
    rxDirections: "",
    rxDirectionsMedType: "",
    rxDirectionsType: "",
    rxDirectionsTime: "",
    rxRefills: "",
    rxRefillsCount: "",
    rxNotes: "",
  });

  const handleReferralsChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReferralsSubmit = (e: any) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <>
      <Dialog
        open={props.referralsOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={props.handleReferralsClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Doctor Refer "}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <form onSubmit={handleReferralsSubmit}>
              {" "}
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                spacing={1}
              >
                <Grid item xs={12}>
                  <Typography variant="body2" component={"label"}>
                    Referring Doctor
                  </Typography>
                  <TextField
                    name="referringDoctor"
                    fullWidth
                    value={formData.referringDoctor}
                    onChange={handleReferralsChange}
                    margin="normal"
                    required
                  />
                </Grid>{" "}
                <Grid item xs={12}>
                  <Typography variant="body2" component={"label"}>
                    Referred Doctor
                  </Typography>
                  <TextField
                    name="referredDoctor"
                    fullWidth
                    value={formData.referredDoctor}
                    onChange={handleReferralsChange}
                    margin="normal"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" component={"label"}>
                    Referral Reason
                  </Typography>
                  <FormControl fullWidth margin="normal" required>
                    <Select
                      name="referralReason"
                      value={formData.referralReason}
                      onChange={handleReferralsChange}
                    >
                      <MenuItem value="Specialist Consultation">
                        Specialist Consultation
                      </MenuItem>
                      <MenuItem value="Diagnostic Test">
                        Diagnostic Test
                      </MenuItem>
                      <MenuItem value="Treatment Recommendation">
                        Treatment Recommendation
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={props.handleReferralsClose}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
